import { createSlice } from "@reduxjs/toolkit";

export type SideMenuState = {
  open: boolean;
};

const initialState: SideMenuState = {
  open: true
};

/** Side Menu Slice */
const { reducer, actions } = createSlice({
  name: "sideMenuSlice",
  initialState,
  reducers: {
    setOpen: (state, { payload }) => {
      state.open = payload;
    }
  }
});

export const { setOpen } = actions;

export default reducer;
